// Returns a warning naming the unresolved context, or null when resolved. Must never
// throw: a throw in the caller's `created` aborts the embedding component's mount too.
export function contextResolutionWarning({
  boundContextName,
  boundField,
  hasContextItem,
  hasRelatedEntity,
  identifier,
}) {
  if (!boundContextName) {
    return `DynamicElementWithContext: element ${identifier} has no context binding — `
      + "set one in the inspector; rendering empty until then";
  }
  if (!hasContextItem) {
    return `DynamicElementWithContext: bound context "${boundContextName}"`
      + `${boundField ? ` (field "${boundField}")` : ""} is missing on this page `
      + `(element ${identifier}) — provide or rebind it via the layers panel / inspector; `
      + "rendering empty until it resolves";
  }
  if (!hasRelatedEntity) {
    // The owning app's Context source may register after the canvas mounts.
    return `DynamicElementWithContext: related entity for context "${boundContextName}" not yet `
      + `available in edit mode (element ${identifier}) — the owning app's context source `
      + "may still be registering; rendering empty until it lands";
  }
  return null;
}
